import { Logger, LoggerService } from "@Shared/logger";
import { PAGE_SUITE_EVENTS, PAGE_SUITE_PAGE_TYPES, PageSuiteArticleViewEvent, PageSuiteOptions, PageSuitePageViewEvent } from "../_models";
import { AsyncUtils, EventUtil } from "@Shared/utils";
import { APP_EVENTS } from "@Core";
import { PageSuiteRepository } from "../repositories";
import { Bus, OnEntitlementDeterminedResult, onLogoutEvent, OnReadyEvent } from "@Modules/event_module";
import { EngageService } from "@Modules/index";




export class PageSuiteService extends PageSuiteRepository {
    private Logger: Logger = LoggerService.createLogger("PageSuiteService");
    private static instance: PageSuiteService;

    static get Instance() {

        if (this.instance === null || this.instance === undefined) {
            this.instance = new PageSuiteService();
        }
        return this.instance;
    }

    


    constructor() {
        super();
        this.Logger.trace("****  CTOR ****");

    }

    public setup(): void {
        this.Logger.trace("setting up PageSuite Service...");
        this.registerEvents();
    }

    public init(options: PageSuiteOptions): Promise<void> {
        this.Logger.trace("initializing PageSuite Service...");

        try {
            //NOTE: Right now this doesn't do anything, but keeping it here in case I need to do something asynchronously while setting up pagesuite (the setup method in this class is not asynchronous)

        } catch (error) {
            this.Logger.error("Error initializing PageSuite Service", error);
        }

        return Promise.resolve();
    }

    // This is used to debounce the pageview event to prevent multiple calls in quick succession. There's a bug where some pageviews triggers this back to back.
    private onPageviewHandler = EventUtil.debounce(this.handleOnPageviewEvent, 25);
    private onArticleviewHandler = EventUtil.debounce(this.handleOnArticleviewEvent, 25);

    private registerEvents(): void {
        this.Logger.trace("registering for PageSuite events...");

        //using window eventlisteners because they are pagesuite events which are at the window level, our custon Bus or EventUtils listeners are at the document level.
        //need to use bind(this) to ensure 'this' context is correct in the handlers (needed for Logger to work properly)
        window.addEventListener(PAGE_SUITE_EVENTS.onLaunch, this.handleOnLaunchEvent.bind(this));
        window.addEventListener(PAGE_SUITE_EVENTS.onPageView, this.onPageviewHandler.bind(this));
        window.addEventListener(PAGE_SUITE_EVENTS.onPageRendered, this.onPageviewHandler.bind(this));
        window.addEventListener(PAGE_SUITE_EVENTS.onArticleView, this.onArticleviewHandler.bind(this));
        window.addEventListener(PAGE_SUITE_EVENTS.onArticleRendered, this.onArticleviewHandler.bind(this));

        //using Bus since we use Bus.emitAndTrack to fire this event for analytics.
        Bus.on(APP_EVENTS.onLogout, this.handleOnLogoutEvent.bind(this));

        //using EventUtils since this can happen many times in the same session (initial load when not logged in and then this is fired after logging in and we don't want to track this in analytics each time)
        EventUtil.listenForEvent(APP_EVENTS.onEntitlementsDetermined, (this.handleOnEntitlementDetermined.bind(this)));
        EventUtil.listenForEvent(APP_EVENTS.onReady, (this.handleonReady.bind(this)));
    }

    private handleOnLaunchEvent(e) {

        try {
            this.Logger.info("Pagesuite Launch Fired", e);
            //this event tells the user-profile-navbar component that pagesuite is ready. So it can inject the template.
            EventUtil.fireEvent(APP_EVENTS.onPagesuiteReady, {});
        } catch (error) {
            this.Logger.error("Error running Connext", error);
        }


    }

    private async handleonReady(event: OnReadyEvent): Promise<void> {
        this.Logger.info("handleonReady", event);
        try {
            const psRegisterResult = await AsyncUtils.waitForWindowMethodAndCall("psRegister" as keyof Window, { intervalMs: 25, debug: true });
            this.Logger.trace("psRegister call result", psRegisterResult);
            if (!event.entitlement || !event.entitlement.mngSession) {
                this.Logger.warn("No entitlement or mngSession found in onReady event, skipping psAuthorise call.");
                return;
            }
            this.Logger.info("Calling psAuthorise with entitlement token");
            const psAuthResult = await AsyncUtils.waitForWindowMethodAndCall("psAuthorise" as keyof Window, { idToken: event.entitlement.mngSession.entitlementToken }, { timeoutMs: 60000, intervalMs: 25, debug: true });
            this.Logger.trace("psAuthorise call result", psAuthResult);

            if (event.entitlement.mngSession.isEntitled) {

                this.handleIsEntitledConnextRun();
            }
        } catch (error) {
            this.Logger.error("Error in handleonReady", error);
        }

    }

    private handleOnLogoutEvent(event: onLogoutEvent): void {
        this.Logger.info("handleOnLogoutEvent", event);
        window['psLogout']?.();
    }

    private handleOnPageviewEvent(e: CustomEvent<PageSuitePageViewEvent>): void {

        try {
            const data = e.detail ?? e;
            this.Logger.info("XXXXXXXXXXXXXXXXXXX handleOnPageviewEvent 2", data);
            this.isArticle = false;
            this.handleContentChange(data as PageSuitePageViewEvent);
            // this.handleOnContentChange(e);

        } catch (error) {
            this.Logger.error("Error handleOnPageviewEvent", error);
        }


    }

    private handleOnArticleviewEvent(e: CustomEvent<PageSuiteArticleViewEvent>): void {

        try {
            const data = e.detail ?? e;
            this.Logger.info("YYYYYYYYYYYYYYYYYYY handleOnArticleviewEvent 2", data);
            this.isArticle = true;            
            this.handleContentChange(data as PageSuiteArticleViewEvent);

        } catch (error) {
            this.Logger.error("Error handleOnArticleviewEvent", error);
        }


    }

    private handleOnEntitlementDetermined(event: OnEntitlementDeterminedResult): void {

        try {
            this.Logger.info("handleOnEntitlementDetermined", event);
            EngageService.Instance.handlePaywallShown();
           
        } catch (error) {
            this.Logger.error("Error handleOnEntitlementDetermined", error);
        }
    }

    /** Remove connext modals and re-run connext. This is needed if the modal is shown and we click the login button in the modal and then login. We don't refresh the page so we need to clear things out here. */
    private handleIsEntitledConnextRun(): void {
        this.Logger.trace("handleIsEntitledConnextRun ", "User is entitled, removing modals and rerunning Connext");
        const modal = document.querySelector(".modal-scrollable");
        if (modal) {
            modal.remove();
        }
        const modalBackdrop = document.querySelector(".connext-modal-backdrop");
        if (modalBackdrop) {
            modalBackdrop.remove();
        }
        window['Connext']?.Run();
    }
}